import {useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {listTopic} from '../../modules/auth/core/_requests'
import {AxiosError} from 'axios'
import DataTable, {TableColumn} from 'react-data-table-component'
import {customStyles} from '../../../dataTableStyle'
import {KTSVG} from '../../../_metronic/helpers'
import {PageTitle} from '../../../_metronic/layout/core'
import AddSMRTopicModal from './Modals/SMRTopicModals/AddSMRTopicModal'
import SMRTopicEditModal from './Modals/SMRTopicModals/SMRTopicEditModal'
import SMRTopicDeletionModal from './Modals/SMRTopicModals/SMRTopicDeletionModal'

type SMRTopicType = {
  id: number
  name: string
  description: string
  command: string
  measurementUnit: string
}

function SMRTopic() {
  const intl = useIntl()
  const [topicList, setTopicList] = useState([])
  const [isChecked, setISChecked] = useState<Array<string>>([])
  const [searchTerm, setSearchTerm] = useState<string>('')
  const [action, setAction] = useState(true)

  useEffect(() => {
    if (action) {
      getList()
      setAction(false)
      setISChecked([])
    }
  }, [action])

  const getList = async () => {
    try {
      const {data} = await listTopic(0)
      setTopicList(data)
    } catch (err) {
      const error = `${(err as AxiosError)?.response?.data}`
      console.error(error)
    }
  }

  const keys = ['description', 'name']

  const search = (list: any) => {
    if (searchTerm) {
      return topicList.filter((item: any) =>
        keys.some((key) => item[key].toLocaleLowerCase().includes(searchTerm.toLocaleLowerCase()))
      )
    } else {
      return topicList
    }
  }

  const columns: TableColumn<SMRTopicType>[] = [
    {
      name: 'Id',
      selector: (row) => row.id,
      sortable: true,
    },
    {
      name: 'Name',
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: 'Description',
      selector: (row) => row.description,
      sortable: true,
    },
    {
      name: 'Command',
      selector: (row) => row.command,
      sortable: true,
    },
    {
      name: 'Measurement Unit',
      selector: (row) => row.measurementUnit,
      sortable: true,
    },
  ]

  const handleSelectId = ({selectedRows}: any) => {
    setISChecked(selectedRows.map((selected: any) => selected.id))
  }

  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.SMRTOPIC'})}</PageTitle>
      <div className='card card-custom gx-xl-10 mt-lg-n16 mt-2'>
        <div className='card-header row p-5 '>
          {/* 👇 Refresh Button - Search Bar 👇 */}
          <div className='d-flex flex-column flex-md-row justify-content-sm-between align-items-sm-center'>
            <div className='d-flex align-items-center'>
              <button
                type='button'
                className='btn btn-light m-2 square border border-secondary'
                onClick={() => setAction(true)}
              >
                <i className='fa-solid fa-rotate-right' />
              </button>
              <div className='d-flex bg-light align-items-center rounded position-relative square border border-secondary w-100 w-xl-450px'>
                <KTSVG
                  path='/media/icons/duotune/general/gen021.svg'
                  className='svg-icon-1 position-absolute ms-5'
                />
                <input
                  type='text'
                  data-kt-user-table-filter='search'
                  className='form-control form-control-solid ps-14'
                  placeholder='Search'
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>
            {/* 👆 Refresh Button - Search Bar 👆 */}
            {/* 👇 Delete - Edit - Add Buttons 👇 */}
            <div className='d-flex flex-column flex-md-row'>
              <button
                type='button'
                className='btn btn-light-warning m-2'
                disabled={isChecked.length === 1 ? false : true}
                data-bs-toggle='modal'
                data-bs-target='#updateSMRTopic_modal'
              >
                Edit
              </button>
              <button
                type='button'
                className='btn btn-light-danger m-2'
                disabled={isChecked.length > 0 ? false : true}
                data-bs-toggle='modal'
                data-bs-target='#deleteSMRTopic_modal'
              >
                Delete
              </button>
              <button
                type='button'
                className='btn btn-light-primary m-2'
                data-bs-toggle='modal'
                data-bs-target='#createSMRTopic_modal'
              >
                Create SMR Topic
              </button>
            </div>
            {/* 👆 Delete - Edit - Add Buttons 👆 */}
          </div>
        </div>

        <div className='card-body table-responsive'>
          <DataTable
            columns={columns}
            data={search(topicList)}
            pagination
            paginationRowsPerPageOptions={[5, 10, 25, 50, 100]}
            paginationPerPage={5}
            customStyles={customStyles}
            className='table table-striped'
            striped
            selectableRows
            onSelectedRowsChange={handleSelectId}
          />
        </div>

        {/*Create Topic Modal */}
        <AddSMRTopicModal setAction={setAction} />
        {/*Update Topic Modal */}
        <SMRTopicEditModal
          editData={
            isChecked ? topicList.filter((item: any) => item.id === Number(isChecked[0]))[0] : []
          }
          setAction={setAction}
        />
        {/*Delete Topic Modal */}
        <SMRTopicDeletionModal checkList={isChecked} setAction={setAction} />
      </div>
    </>
  )
}

export default SMRTopic
